import { cloneElement } from 'react';
import { ChainIconType, getChainIcon } from '../../assets/chains';
import Forward from '../../assets/icons/Forward';
import { FlexLeft, PageContent } from '../../components/modal/styles';
import { ForwardContainer, WalletItem, WalletLable } from '../../components/wallets/styles';
import type { WalletData } from '../../components/wallets/types';
import { useConnectWithWallet } from '../../hooks/useConnectWithWallet';
import useLocales from '../../hooks/useLocales';
import { Links, Title, WalletIconContainer, Wrapper } from '../downloadApp/styles';

const supportedChains = {
  evm: getChainIcon(ChainIconType.Eth),
  solana: getChainIcon(ChainIconType.Sol),
} as const;

const Page = ({ walletData }: { walletData: WalletData }) => {
  const locales = useLocales();
  const connectWallet = useConnectWithWallet();
  return (
    <PageContent style={{ marginTop: 0 }}>
      <Wrapper>
        <WalletIconContainer>
          {!!walletData?.props?.[0]?.icon && cloneElement(walletData?.props?.[0].icon as React.ReactElement, {})}
        </WalletIconContainer>
        <Title
          style={{
            marginBottom: '40px',
          }}
        >
          <div>{locales.walletSupportsMultipleChains}</div>
          <div>{locales.selectChainToConnect}</div>
        </Title>
        <Links>
          {walletData.props.map((item, index: number) => (
            <WalletItem key={index} onClick={() => connectWallet(item)}>
              <FlexLeft gap={10}>
                {supportedChains[item.connector.chainType]()}
                <div
                  className='label'
                  style={{
                    fontSize: 14,
                  }}
                >
                  {item.connector.chainType.toUpperCase()}
                </div>
              </FlexLeft>
              {item.isInstalled && <WalletLable $customLable={false}>{locales.installed}</WalletLable>}
              <ForwardContainer>
                <Forward />
              </ForwardContainer>
            </WalletItem>
          ))}
        </Links>
      </Wrapper>
    </PageContent>
  );
};

export default Page;
